import { z } from "zod";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { MODELOS, STATUS } from "./status";

export const schemaFiltro = z
	.object({
		dtIni: z.date({
			required_error: "Data inicial é obrigatória",
			invalid_type_error: "Data inicial inválida",
		}),
		dtFim: z.date({
			required_error: "Data final é obrigatória",
			invalid_type_error: "Data final inválida",
		}),
		modelo: z.string(),
		status: z.string(),
		venda: z.string(),
		cliente: z.string(),
		cpfCnpj: z.string(),
	})
	.refine((data) => data.dtIni <= data.dtFim, {
		message: "A data inicial deve ser menor ou igual à data final",
		path: ["dtIni"],
	});

const APLICADOS = [
	{ campo: "modelo", label: "Modelo", valor: (v) => MODELOS[v] },
	{ campo: "status", label: "Status", valor: (v) => STATUS[v].rotulo },
	{ campo: "venda", label: "Venda" },
	{ campo: "cliente", label: "Cliente" },
	{ campo: "cpfCnpj", label: "CPF/CNPJ" },
];

export function filtrosIniciais() {
	return {
		dtIni: startOfMonth(new Date()),
		dtFim: endOfMonth(new Date()),
		modelo: "",
		status: "",
		venda: "",
		cliente: "",
		cpfCnpj: "",
	};
}

export function listarAplicados(f) {
	const periodo = { label: "Período", value: `${format(f.dtIni, "dd/MM/yyyy")} a ${format(f.dtFim, "dd/MM/yyyy")}` };
	const demais = APLICADOS.filter(({ campo }) => f[campo]).map(({ campo, label, valor = (v) => v }) => [
		campo,
		{ label, value: valor(f[campo]) },
	]);

	return { periodo, ...Object.fromEntries(demais) };
}

export function paraConsulta(f) {
	return { ...f, dtIni: format(f.dtIni, "yyyy-MM-dd"), dtFim: format(f.dtFim, "yyyy-MM-dd") };
}

export function alternarModal(ident) {
	window.dispatchEvent(new CustomEvent(ident));
}
